import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { api, sendAsync } from '../../../app/applicationSlice'
import { RootState, RootThunk, RootThunkApi } from '../../../app/store'
import { BlindFileListPage, BlindFileListParams, CounselorListTimePage, DoctorsInDepartmentTimeList } from '../../../services/treatment'


export const getBlindFileListPage = createAsyncThunk<
  void,
  BlindFileListParams,
  RootThunkApi
>('ToothHome/getBlindFileListPage', async (params, api) => {
  return sendAsync(BlindFileListPage(params), api)
})

export const getCounselorListTimePage = createAsyncThunk<
  any,
  void,
  RootThunkApi
>('ToothHome/getCounselorListTimePage', async (params, api) => {
  return sendAsync(CounselorListTimePage(), api)
})

export const getDoctorsInDepartmentTimeListAsync = createAsyncThunk<
  any,
  void,
  RootThunkApi
>('ToothHome/getDoctorsInDepartmentTimeListAsync', async (params, api) => {
  return sendAsync(DoctorsInDepartmentTimeList(), api)
})
